<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.2709 4.16406H7.78216C4.84281 4.16406 3 6.24525 3 9.19044V14.8064C3 17.7516 4.83405 19.8328 7.78216 19.8328H16.2159C19.165 19.8328 21 17.7516 21 14.8064V11.1364"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M17.6695 4.73482L20.4283 7.49367M20.4285 4.7351L17.6696 7.49397"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M8.38477 9.88281H11.7221M8.38477 14.1187H15.614"
      stroke="#A3A3A3"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
